import { FullPageLoader } from "@/components/ui/loader";
import { useIsRendered } from "@/shared/useIsRendered";
import { type ReactNode } from "react";

type ClientOnlyProps = {
  children: ReactNode;
  showLoader?: boolean;
};

export function ClientOnly({ children, showLoader = false }: ClientOnlyProps) {
  const isRendered = useIsRendered();

  if (!isRendered) {
    return showLoader ? <FullPageLoader /> : null;
  }

  return children;
}
